/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import SaveCancelPopup from '../../../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { getUTCTimeStampMMDDYYYY } from '../../../../../../../SharedModules/DateUtilities/DateUtilities';
import DisplayErrorMessages from '../../../../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../../../../SharedModules/SVGComponents/SVGComponents';
import { validDate } from '../../../../../../Maintain/group/Components/maintainGroup';
import { updateNDCDetails } from '../../../../store/action';
import { CMS_DRUG_URA_CORRECTION_TABLEHEAD } from '../../../../utility/tableHeads';
import CMSDrugURATableComponent from './CMSDrugURATableComponent';
import {
  checkActionAccessByRole,
  PaperComponent,
} from '../../../../../../../SharedModules/utilities/utilities';

const CMSDrugURAUpdationDialog = ({ open, data, handleClose }) => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState([]);
  const [cancelOpen, setCancelOpen] = useState({ open: false, type: 'Cancel' });
  const [disableSaveAndCancel, setDisableSaveAndCancel] = useState(true);
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const handleCancelClose = () => {
    setCancelOpen({ open: false, type: 'Cancel' });
    setDisableSaveAndCancel(true);
  };

  const onSaveClick = () => {
    const error = [];
    if (data && data.data && data.data[0]) {
      if (!data.data[0].newUnitRebateAmt) {
        error.push('Please Enter New URA.');
      }
      // if (!data.data[0].newTerminationDt)
      //   error.push('Please enter Termination Date.');
      if (
        data.data[0].newTerminationDt &&
        !validDate(new Date(data.data[0].newTerminationDt))
      ) {
        error.push(
          'Please enter a valid date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits.'
        );
      }

      setErrorMessage(error);
      if (error.length > 0) {
        handleCancelClose();
        return;
      }
      const apiRequest = { ...data.data[0] };
      apiRequest.unitRebateAmt = apiRequest.newUnitRebateAmt
        ? parseFloat(apiRequest.newUnitRebateAmt)
        : apiRequest.unitRebateAmt;
      apiRequest.corrLinkId = null;
      apiRequest.loadDt = getUTCTimeStampMMDDYYYY(new Date());
      apiRequest.cmsDrugId.loadDt = getUTCTimeStampMMDDYYYY(new Date());
      apiRequest.cmsDrugId.cmsUraRecordTypeCd = '3';

      apiRequest.terminationDt =
        (apiRequest.newTerminationDt &&
          getUTCTimeStampMMDDYYYY(apiRequest.newTerminationDt)) ||
        apiRequest.terminationDt;
      delete apiRequest.newTerminationDt;
      delete apiRequest.newUnitRebateAmt;

      dispatch(updateNDCDetails(apiRequest, data.index));
      handleCancelClose();
      handleClose();
    }
  };

  useEffect(() => {
    return () => {
      setErrorMessage([]);
    };
  }, []);

  return (
    <div>
      <Dialog
        open={open}
        className={clsx(
          'multiGroupDialog custom-dialog-box',
          'dialogPanel custom-check dialog-700 common-popup'
        )}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <div style={{ cursor: 'move' }} id="draggable-dialog-title">
          <DialogContent>
            <div className="custom-panel">
              <div className="panel-header">
                <span className="float-left"> Correct CMS Drug </span>
                <span
                  className="float-right"
                  role="button"
                  onClick={handleClose}
                >
                  <i className="fa fa-times-circle" aria-hidden="true" />
                </span>
                <div className="clearfix" />
              </div>
              <div className="col-12 ">
                <DisplayErrorMessages
                  errorMessages={[...new Set(errorMessage)]}
                />
                <CMSDrugURATableComponent
                  tableData={(data && data.data) || []}
                  tableHead={CMS_DRUG_URA_CORRECTION_TABLEHEAD}
                  setDisableSaveAndCancel={setDisableSaveAndCancel}
                  hasAccess={hasAccess}
                  setErrorMessage={setErrorMessage}
                  errorMessage={errorMessage}
                  isEnablebyRole={isEnablebyRole}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions className="justify-end">
            <div className="float-right">
              <div className="btn-wrapper my-2 mx-auto">
                <div className="float-right hide-on-print">
                  <Button
                    disabled={isEnablebyRole || disableSaveAndCancel}
                    onClick={() => setCancelOpen({ open: true, type: 'Save' })}
                    color="primary"
                    className="btn btn-success btn-search mr-2"
                  >
                    <SVGComponent iconName="Icon-awesome-save" />
                    Save
                  </Button>
                  <Button
                    disabled={isEnablebyRole || disableSaveAndCancel}
                    autoFocus
                    onClick={() =>
                      setCancelOpen({ open: true, type: 'Cancel' })
                    }
                    color="primary"
                    className="btn btn-cancel btn-primary"
                  >
                    <SVGComponent iconName="Icon-cancel" />
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </DialogActions>
        </div>
      </Dialog>
      <SaveCancelPopup
        open={cancelOpen.open}
        title={cancelOpen.type}
        onConfim={() => {
          if (cancelOpen.type === 'Save') {
            onSaveClick();
          } else {
            handleCancelClose();
            handleClose();
          }
        }}
        onCancel={handleCancelClose}
        moduleName=""
      />
    </div>
  );
};

export default CMSDrugURAUpdationDialog;
